
import moment from 'moment';
import { Model } from './_model';
import { getUserSessionInfo } from './../helpr/clientSession';

export default class Order extends Model {
  get defaults() {
    return {
      orderId: '',
      refNumber: '',
      securityId: '',
      atpNumber: '',
      accountNames: '',
      investorCategory: 'INDV',
      primaryApplicant: '',
      applicantList: {
        applicants: [{
          first_name: '',
          last_name: '',
          middle_name: '',
          date_of_birth: '',
          email: ''
        }],
        assoc: ''
      },
      primaryContactPerson: {
        lastName: '',
        firstName: '',
        middleName: '',
        relation: ''
      },
      nationality: '',
      dateOfBirthOrIncorporation: '',
      placeOfBirthOrIncorporation: '',
      idType: 'TINN',
      idNumber: '',
      purchaseAmount: '',
      scaledAmount: '',
      address: {
        streetAddress: '',
        districtOrTown: '',
        city: '',
        stateProvinceRegion: '',
        country: '',
        zipCode: ''
      },
      presentAddress: {
        streetAddress: '',
        districtOrTown: '',
        city: '',
        stateProvinceRegion: '',
        country: '',
        zipCode: ''
      },
      mailingAddress: '',
      place: '',
      taxStatus: '',
      businessDetails: {
        parentCompany: '',
        name: '',
        nature: '',
        sourcesOfIncome: []
      },
      contactNumbers: {
        telephoneNumbers: [{
          number: ''
        }],
        faxNumbers: [{
          number: ''
        }]
      },
      modeOfCollectionOfInterest: '',
      modeOfPayment: {
        option: '',
        bank: '',
        checkNumber: '',
        debitAccountNumber: ''
      },
      statementDeliveryMode: '',
      settBankCode: '',
      bankPesoAccountNumber: '',
      securityRegistration: '',
      pdtcDepositoryParticipantName: '',
      applicantNoCDBPID: '',
      pdtcDepositoryParticipantBPID: '',
      pdtcDepositoryParticipantOmnibusAccNo: '',
      emailAddress: '',
      bpId: '',
      orderStatus: '',
      generatedFromFileUpload: '',
      createdDate: '',
      lastUpdatedDate: '',
      orderDate: moment().format('YYYY-MM-DD hh:mm:ss'),
      checked: false
    }
  }

}


